import React, {ChangeEventHandler, createRef, FormEventHandler, useEffect, useRef, useState} from "react";

import './MessageComposeField.scss'
import EmojiPicker, {Theme} from "emoji-picker-react";
import type {ConferenceUser, UserFromToken} from "@inpriton/types";

type Props = {
  users: ConferenceUser[],
  value: string,
  onChange: ChangeEventHandler<HTMLTextAreaElement>,
  onSubmit: () => void,
  onTyping?: (typing: boolean) => void,
  typingUsers: string[],
  user: UserFromToken
}

let typingTimeout: any | null = null

export default (props: Props) => {
  const inputRef = createRef<HTMLTextAreaElement>()

  const [shift, setShift] = useState(false)

  const [fieldValue, setFieldValue] = useState(props.value)

  const [rows, setRows] = useState(1)

  const [typing, setTyping] = useState(false)

  const [showMediaSelector, setShowMediaSelector] = useState(false)
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)

  useEffect(() => {
    setRows(fieldValue.split("\n").length)
  }, [fieldValue]);

  useEffect(() => {
    setFieldValue(props.value)
  }, [props.value]);

  useEffect(() => {
    if (typeof props.onTyping !== 'undefined') {
      props.onTyping(typing)
    }
  }, [typing]);

  const onSubmit = (e?: any) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }

    if (!fieldValue) {
      return
    }

    props.onSubmit()

    if (typing) {
      setTyping(false)
    }
    if (typingTimeout) {
      clearTimeout(typingTimeout)
    }
    inputRef.current?.focus()
  }

  const onInput = (e: any) => {
    if (typingTimeout) {
      clearTimeout(typingTimeout)
    }

    setTyping(true)

    typingTimeout = setTimeout(() => {
      setTyping(false)
    }, 2000)

    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout)
      }
    }
  }

  const onKeyDown = (e: any) => {
    const keycode = e.keyCode

    var valid =
      (keycode > 47 && keycode < 58) || // number keys
      keycode === 32 || keycode === 13 || // spacebar & return key(s) (if you want to allow carriage returns)
      (keycode > 64 && keycode < 91) || // letter keys
      (keycode > 95 && keycode < 112) || // numpad keys
      (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
      (keycode > 218 && keycode < 223);   // [\]' (in order)

    if (e.key === 'Shift') {
      setShift(true)
    }
    if (e.key === 'Enter' && !shift) {
      e.preventDefault()
      e.stopPropagation()
    }
  }
  const onKeyUp = (e: any) => {
    if (e.key === 'Shift') {
      setShift(false)
      return
    }
    if (e.key === 'Enter' && !shift) {
      e.preventDefault()
      e.stopPropagation()
      onSubmit()
    }
  }

  const toggleEmojiPicker = (e: any) => {
    e.preventDefault()
    e.stopPropagation()
    setShowEmojiPicker(!showEmojiPicker)
  }

  const onEmojiClick = (e: any) => {
    setFieldValue(fieldValue + e.emoji)
  }

  // @ts-ignore
  const typingUsers: ConferenceUser[] = props.typingUsers.map(uuid => props.users.find(u => u.uuid === uuid))
    .filter(user => typeof user !== 'undefined')
    // @ts-ignore
    .filter(user => user.uuid !== props.user.uuid)

  return (
    <div className="message-compose-field">

      {typingUsers.length === 1 ? (
        <div className="typing-indicator">
          {typingUsers.map(user => user.name || user.email)} is typing&hellip;
        </div>
      ) : null}
      <form onSubmit={onSubmit}>
        <div className="left">
          <div className="inner">
          </div>
        </div>

        <textarea
          ref={inputRef}
          rows={rows}
          value={fieldValue}
          onChange={props.onChange}
          onKeyUp={onKeyUp}
          onKeyDown={onKeyDown}
          onInput={onInput}
          placeholder="Write a message..."
        ></textarea>

        <div className="right">
          <div className="inner">
            <button type="submit">
              <i className="fa-regular fa-paper-plane"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}